import { render } from "./BookingNavigator.vue?vue&type=template&id=90e07906"
import script from "./BookingNavigator.vue?vue&type=script&lang=js"
export * from "./BookingNavigator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\Furbetta\\WebAppPrenotazionePrimaVisita\\booking-prima-visita-v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__